import React, { useEffect } from "react";
import { useTabs } from "../hooks/useTabs";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Checkbox from "../ui/Checkbox";
import Space from "../ui/Space";
import DateInput from "../ui/DateInput";
import { arrayToObject } from "../utils/Utils";
import dayjs from "dayjs";

export default function POSHeaderExtras(props) {

    const { controller = "", route = "", selected = {}, callback = () => { } } = props;

    //  "hold_till", "cancel_date", "partial", "per","ship_via", "terms", "notes" // combine? max value?

    const defaultTabs = [
        { key: "per", value: selected?.per, skip: false },
        { key: "cancel_date", value: selected?.cancel_date, skip: false },
        { key: "combine", value: selected?.combine, skip: false },
        { key: "partial", value: selected?.partial, skip: false },
        { key: "hold_till", value: selected?.hold_till, skip: false },
        { key: "max_value", value: selected?.hold_till, skip: false },
    ]

    console.log(defaultTabs)
    const {
        tabs, setTabs, index, setIndex, update, updateSkip, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "per");


    const actions = [
        { key: KBD.ESCAPE, action: () => callback(false) },
        { key: KBD.PAGE_DOWN, action : () => processAndCallback(tabs)},
        { key: KBD.ARROW_DOWN, action: () => next() },
        { key: KBD.ARROW_UP, action: () => prev() },
    ]
    useEffect(() => {

        if (window.bm_state.value === route) {
            if (refs?.current[index]) refs.current[index].focus();
        }

        const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]);
        return cleanup;

    }, [tabs, index])

    const processAndCallback = (_arr = tabs) => {
        let _ret = arrayToObject(_arr);
        _ret.cancel_date = (_ret.cancel_date) ? dayjs(_ret.cancel_date).valueOf() : 0;
        _ret.hold_till = (_ret.hold_till) ? dayjs(_ret.hold_till).valueOf() : 0;
        callback(_ret);
    }

    return (
        <div style={{"width" : "350px"}}>
            <div className="shim" /><div className="shim" />
            <Space>
                <Label width={80}>Attn</Label>
                <Input {...editProps("per")} onEnter={() => next()} placeholder="Attn..." />
            </Space>
            <div className="shim" />
            <Space>
                <Label width={80}>Cancel Date</Label>
                <DateInput width={100}{...editProps("cancel_date")} onEnter={() => next()} onFilled={(e) => {update("cancel_date", e); next();}} />
            </Space>
            <div className="shim" />
            <Space>
                 <Label width={80}>&nbsp;</Label>
                <Input width={15} style={{"textAlign" : "center"}} chars={["Y", "N"]} uppercase {...editProps("combine")} onChange={(e) => {
                    if(e == "Y"){
                        update("combine", 1)
                    } else {
                        update("combine", 0)
                    }
                    next()
                }} value={getVal("combine") ? "Y" : "N"} onEnter={() => next()} />
                <Label width={80}><nobr>Combine with other orders?</nobr></Label>
            </Space>
            <div className="shim" />
            <Space>
                  <Label width={80}>&nbsp;</Label>
                <Input width={15} style={{"textAlign" : "center"}} chars={["Y", "N"]} uppercase {...editProps("partial")} onChange={(e) => {
                    if(e == "Y"){
                        update("partial", 1)
                    } else {
                        update("partial", 0)
                    }
                    next()
                }} value={getVal("partial") ? "Y" : "N"} onEnter={() => next()} />
                <Label width={80}><nobr>Allow partial shipments?</nobr></Label>
            </Space>
            <div className="shim" />
            <Space>
                <Label width={80}>Hold Until</Label>
                <DateInput width={100}{...editProps("hold_till")} onEnter={() => next()} onFilled={(e) => {update("hold_till", e); next();}} />
            </Space>
            <div className="shim" />
            <Space>
                <Label width={80}>Max Value</Label>
                <Input width={100} price placeholder="Max value..." {...editProps("max_value")} onEnter={(e) => {setTimeout(processAndCallback(), 100)}} />
            </Space>
        </div>
    )
}